import React from 'react';

const CloseIcon = ({ fill = 'white' }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_51_264"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_264)">
        <path
          d="M2.37565 15.3462L1.34619 14.3167L6.81673 8.84619L1.34619 3.37565L2.37565 2.34619L7.84619 7.81673L13.3167 2.34619L14.3462 3.37565L8.87565 8.84619L14.3462 14.3167L13.3167 15.3462L7.84619 9.87565L2.37565 15.3462Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default CloseIcon;
